"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAGE_ANCHORS = void 0;
exports.PAGE_ANCHORS = {
    TOP_ANCHOR_ID: 'SCROLL_TO_TOP',
    TOP_ANCHOR_COMP_ID: 'PAGE_TOP_ANCHOR',
};
//# sourceMappingURL=constants.js.map